import { useState, useEffect } from "react"
import api from '../../utils/api'

import Input from "../../shared/components/form/input"

// Reaproveita o CSS do modal de NCM — layout de busca genérico (header/lista/item).
import './NcmSearchModal.css'

function ClientSearchModal({ onSelect }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const [clients, setClients] = useState([])
    const [query, setQuery] = useState('')
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        api.get('/client/getall', {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        }).then((response) => {
            setClients(response.data.clients || [])
            setLoading(false)
        }).catch(() => setLoading(false))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const q = query.trim().toLowerCase()
    const results = q
        ? clients.filter((c) => c.name?.toLowerCase().includes(q) || c.CPF?.includes(q) || c.CNPJ?.includes(q))
        : clients

    return (
        <div className="ncm-search">
            <div className="ncm-search-header">
                <p className="ncm-search-title">Buscar Cliente</p>
                <span className="ncm-search-title-accent" />
                <p className="ncm-search-subtitle">Selecione um cliente cadastrado pra preencher o destinatário automaticamente. Os dados continuam editáveis depois.</p>
            </div>

            <Input type="text" placeholder="Buscar por nome, CPF ou CNPJ..." value={query} handleOnChange={(e) => setQuery(e.target.value)} />

            <div className="ncm-search-results">
                {loading && <p className="ncm-search-empty">Carregando...</p>}
                {!loading && results.length === 0 && (
                    <p className="ncm-search-empty">{query ? `Nenhum cliente encontrado para "${query}".` : 'Nenhum cliente cadastrado ainda.'}</p>
                )}
                {results.map((c) => (
                    <div key={c._id} className="ncm-search-item" onClick={() => onSelect(c)}>
                        <span className="ncm-search-item-code">{c.personType === 'juridica' ? 'PJ' : 'PF'}</span>
                        <span className="ncm-search-item-desc">
                            {c.name}
                            {c.CPF ? ` — CPF ${c.CPF}` : ''}
                            {c.CNPJ ? ` — CNPJ ${c.CNPJ}` : ''}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default ClientSearchModal
